<template>
  <div class="c-nav-mobile">
      <input type="checkbox" class="checkbox" id="menu-toogle" />
      <label for="menu-toogle" class="c-nav-mobile__toggle"></label>
      <nav class="c-nav-mobile__responsive">
          <ul class="c-nav-mobile__responsive--primary">
              <li class="c-nav-mobile__responsive--primary-item"><router-link :to="{name: 'experiments'}">{{ $t('nav.experiments')}}</router-link></li>
              <li class="c-nav-mobile__responsive--primary-item"><router-link :to="{name: 'configuration'}">{{ $t('nav.configuration')}}</router-link></li>
          </ul>
      </nav>
  </div>
</template>

<style lang="scss">

</style>

<script>
export default {
  name: 'NavMobile',
}
</script>
